(() => {
  const CONFIG_SELECTOR = '[data-eg-digital-config]';
  const PRODUCT_MODULE_SELECTOR = '[data-eg-digital-product-module]';
  const QUICK_BENEFITS_SELECTOR = '[data-eg-digital-quick-benefits]';

  const readConfig = () => {
    const node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return null; }
  };

  const setText = (root, field, value) => {
    if (!root || value === undefined || value === null || value === '') return;
    root.querySelectorAll(`[data-eg-digital-field="${field}"]`).forEach((node) => { node.textContent = value; });
  };

  const setHref = (root, key, value) => {
    if (!root || !value) return;
    root.querySelectorAll(`[data-eg-digital-link="${key}"]`).forEach((node) => { node.href = value; });
  };

  const regionalize = (template, region, fallback = '') => {
    const text = String(template || '');
    if (!text) return fallback;
    if (region) {
      return text
        .replace(/\{region\}/g, region)
        .replace(/Estados Unidos/gi, region)
        .replace(/United States/gi, region)
        .replace(/\bUSA\b/gi, region);
    }
    if (text.includes('{region}') || /Estados Unidos|United States|\bUSA\b/i.test(text)) return fallback || '¿Qué significa la región del código?';
    return text;
  };

  const channelList = (config) => {
    const channels = [
      [config.showWhatsapp, config.whatsappLabel],
      [config.showFacebook, config.facebookLabel],
      [config.showEmail, config.emailLabel],
      [config.showInstagram, config.instagramLabel]
    ].filter(([enabled, label]) => enabled && label).map(([, label]) => label);
    if (!channels.length) return '';
    if (channels.length === 1) return channels[0];
    if (channels.length === 2) return `${channels[0]} o ${channels[1]}`;
    return `${channels.slice(0, -1).join(', ')} o ${channels[channels.length - 1]}`;
  };

  const syncQuickBenefits = (config) => {
    document.querySelectorAll(QUICK_BENEFITS_SELECTOR).forEach((root) => {
      root.hidden = config.showQuickBenefits === false;
      setText(root, 'quickBenefit1Title', config.quickBenefit1Title);
      setText(root, 'quickBenefit1Text', config.quickBenefit1Text);
      setText(root, 'quickBenefit2Title', config.quickBenefit2Title);
      setText(root, 'quickBenefit2Text', config.quickBenefit2Text);
      setText(root, 'quickBenefit3Title', config.quickBenefit3Title);
      setText(root, 'quickBenefit3Text', config.quickBenefit3Text);
    });
  };

  const syncProductCards = (config) => {
    document.querySelectorAll(PRODUCT_MODULE_SELECTOR).forEach((root) => {
      const delivery = root.querySelector('[data-eg-digital-card="delivery"]');
      const before = root.querySelector('[data-eg-digital-card="before-buy"]');
      const faq = root.querySelector('[data-eg-digital-card="faq"]');
      if (delivery) delivery.hidden = config.showDeliveryCard === false;
      if (before) before.hidden = config.showBeforeBuy === false;
      if (faq) faq.hidden = config.showFaq === false;

      [
        'deliveryCardTitle','title','deliveryTime','deliverySuffix','noShippingText','howItWorksTitle',
        'step1Title','step1Text','step2Title','step2Text','step3Title','step3Text','beforeBuyTitle',
        'regionLabel','redeemLabel','paymentLabel','beforePaymentText','receiveLabel','returnsLabel','returnsText',
        'faqTitle','faq2Question','faq2Answer','faq3Question','faq3Answer','faq4Question','faq4Answer',
        'faqNintendoLabel','faqPlaystationLabel','faqXboxLabel','faqWhatsappLabel'
      ].forEach((field) => setText(root, field, config[field]));

      const region = String(root.dataset.egDigitalRegion || '').trim();
      setText(root, 'faq1Question', regionalize(config.faq1Question, region, config.faqRegionFallbackQuestion || '¿Qué significa la región del código?'));
      setText(root, 'faq1Answer', regionalize(config.faq1Answer, region, config.faq1Answer));

      setHref(root, 'nintendo', config.faqNintendoUrl);
      setHref(root, 'playstation', config.faqPlaystationUrl);
      setHref(root, 'xbox', config.faqXboxUrl);
      setHref(root, 'whatsapp', config.faqWhatsappUrl);

      const channels = channelList(config);
      root.querySelectorAll('[data-eg-digital-channels-list]').forEach((node) => {
        node.textContent = channels;
        const row = node.closest('[data-eg-digital-channel-row]');
        if (row) row.hidden = !channels;
      });
    });
  };

  const apply = () => {
    const config = readConfig();
    if (!config || config.enabled === false) return;
    syncQuickBenefits(config);
    syncProductCards(config);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();

  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(apply));
})();
